import CustomerAccount from "models/account/customer/customerAccount";
import { Subdomain } from "../../../shared/Enums";

export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_MODAL_LOADING = 'TOGGLE_MODAL_LOADING';
export const TOGGLE_API_REQUEST_SUCCESS = 'TOGGLE_API_REQUEST_SUCCESS';
export const LOGGED_IN_ACCOUNT = 'LOGGED_IN_ACCOUNT';
export const SET_SUBDOMAIN = 'SET_SUBDOMAIN';
export const SET_ID_VERIFICATION_TOKEN= 'SET_ID_VERIFICATION_TOKEN';

export interface SystemState {
    isLoading: boolean;
    isModalLoading: boolean;
    // Using as a way for us to close modals when the request we have sent has been successful
    apiRequestSuccess: boolean;
    loggedInAccount: CustomerAccount;
    subdomain: Subdomain
}

interface ToggleLoadingAction {
    type: typeof TOGGLE_LOADING;
    payload: {
        isLoading: boolean;
    }
}
 
interface ToggleModalLoadingAction {
    type: typeof TOGGLE_MODAL_LOADING;
    payload: {
        isModalLoading: boolean;
    }
}

interface ToggleAPIRequestSuccessAction {
    type: typeof TOGGLE_API_REQUEST_SUCCESS;
    payload: {
        apiRequestSuccess: boolean;
    }
}

interface GetLoggedInAccount {
    type: typeof LOGGED_IN_ACCOUNT;
    payload: {
        customerAccount: CustomerAccount;
    }
}

interface SetSubdomain {
    type: typeof SET_SUBDOMAIN;
    payload: {
        subdomain: Subdomain;
    }
}

interface IdentityVerificationTokenState {
    type: typeof SET_ID_VERIFICATION_TOKEN;
    payload: {
      token: string;
      tokenExpirationDate: Date;
    };
  }

export type SystemActionTypes =
  | ToggleLoadingAction
  | ToggleModalLoadingAction
  | ToggleAPIRequestSuccessAction
  | GetLoggedInAccount
  | SetSubdomain
  | IdentityVerificationTokenState;